import React, { useMemo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
//Import Breadcrumb
import { Container } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import { Search, Upload } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
} from "../../components/shared/dialog";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/shared/alertDialog";

import Paginate from "../../components/shared/paginate";
import { X } from "lucide-react";
import {
  DownloadCSV,
  FetchDocuments,
  SearchDocuments,
  UpdateStatus,
} from "../../apis/Documents";

const DocumentVerification = () => {
  const [currentPage, setCurrentPage] = useState("1");
  const [totalPages, setTotalPages] = useState("1");
  // const [users, setUsers] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [dataInCSV, setDataInCSV] = useState("");
  const [keyword, setKeyword] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [reasonError, setReasonError] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState(false);

  const limit = "10";

  const fetchDocuments = async () => {
    try {
      const response = await FetchDocuments(currentPage, limit); // Assuming FetchHouseTypes is the correct function from your API
      if (response.success) {
        setFilteredDocuments(response?.data?.documents);
        setTotalPages(response?.data?.totalPages);
      } else {
        toast.error("Failed to fetch reviews. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to fetch reviews. Please try again later.");
    }
  };

  const downloadCSV = () => {
    DownloadCSV().then((res) => {
      setDataInCSV(res);
    });
  };

  useEffect(() => {
    downloadCSV();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchDocuments = async () => {
    try {
      const response = await SearchDocuments(keyword, currentPage, limit);
      if (response.success) {
        setFilteredDocuments(response?.data?.documents);
        setTotalPages(response?.data?.totalPages);
      } else {
        toast.error("Failed to search documents. Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to search documents. Please try again later.");
    }
  };

  useEffect(() => {
    if (keyword) {
      searchDocuments();
    } else {
      fetchDocuments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, keyword]);

  useEffect(() => {
    if (keyword) {
      setCurrentPage("1");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  const columns = useMemo(
    () => [
      "Profile ID",
      "Host name",
      "host Email",
      "Requested files",
      "Action",
    ],
    []
  );

  const handleStatusChange = async (status, reviewId) => {
    try {
      const response = await UpdateStatus(reviewId, status);
      if (response?.success) {
        toast.success("Review status updated");
        const tempReviews = filteredDocuments.map((review) => {
          if (review._id === reviewId)
            return {
              ...review,
              status,
            };
          else return review;
        });
        setFilteredDocuments(tempReviews);
      } else toast.error("Failed to update review status");
    } catch (err) {
      toast.error("Failed to update review status");
    }
  };

  const handleDocumentStatus = (profileId, status) => {
    if (status)
      UpdateStatus(profileId, status).then((res) => {
        const tempDocuments = filteredDocuments.map((document) => {
          if (document.profileId === profileId)
            return {
              ...document,
              status: status,
            };
          else return document;
        });
        setFilteredDocuments(tempDocuments);
        toast.success("Document status updated");
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container
        //  h-[calc(100vh-130px)]
        className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]"
        fluid
      >
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">
            Manage document verification
          </h1>
          <div className="lg:flex flex-col lg:border lg:border-b-0 border-gray-400 dark:border-white">
            <div className="border-x border-t lg:border-none border-gray-500 dark:border-white rounded-[6px_6px_0px_0px] w-full flex flex-col lg:flex-row justify-between gap-4 p-4">
              <div className="relative border max-w-[400px] border-gray-500 dark:border-white rounded-md w-full">
                <Search
                  size={16}
                  className="absolute left-2 bottom-1/2 translate-y-1/2"
                />
                <input
                  className="pl-8 pr-6 py-2 text-base rounded-md w-full dark:bg-darkBg2"
                  type="search"
                  placeholder="Search"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
              <div className="flex lg:justify-self-end">
                <a
                  href={`data:text/csv;charset=utf-8,${escape(dataInCSV)}`}
                  download="documents-list.csv"
                >
                  <div className="flex items-center gap-2">
                    Export data into CSV
                    <div className="shrink-0 bg-white p-1">
                      <Upload className="" size={16} />
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="overflow-x-auto ">
              <div className="hidden lg:flex">
                {columns.map((column, index) => (
                  <div
                    key={`column-${index}`}
                    className={`${
                      index === 0 ? "w-[20%]" : "w-[20%]"
                    } min-w-[130px] content-center border-y border-gray-500 dark:border-white break-words py-2 text-center font-semibold`}
                  >
                    {column}
                  </div>
                ))}
              </div>
              {(filteredDocuments &&
                filteredDocuments.length > 0 &&
                filteredDocuments.map((document, index) => (
                  <>
                    <div
                      key={`document-desktop-${index}`}
                      className="hidden lg:flex"
                    >
                      <div className="w-[20%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {document.profileId}
                      </div>
                      <div className="w-[20%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {document.hostName}
                      </div>
                      <div className="w-[20%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {document.hostEmail}
                      </div>
                      <div className="w-[20%] min-w-[130px] px-1 flex flex-col gap-2 justify-center items-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        {document.documents?.map((file, index) => (
                          <Link
                            to={file.path}
                            key={`file-${index}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {file.displayKey}
                          </Link>
                        ))}
                      </div>
                      <div className="w-[20%] min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                        <select
                          value={document.status}
                          onChange={(event) =>
                            handleDocumentStatus(
                              document.profileId,
                              event.target.value
                            )
                          }
                          className="p-2 border border-gray-500 dark:border-white rounded-md dark:bg-darkBg2"
                        >
                          <option value={null} disabled>
                            Select
                          </option>
                          <option value={"pending"}>Pending</option>
                          <option value={"approved"}>Approved</option>
                          <option value={"rejected"}>Rejected</option>
                        </select>
                      </div>
                    </div>
                    <div
                      key={`document-mobile-${index}`}
                      className="block lg:hidden mb-6 border-x border-y border-gray-500 dark:border-white"
                    >
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Profile ID </div>
                        <div>{document.profileId}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Host name </div>
                        <div>{document.hostName}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Host Email </div>
                        <div>{document.hostEmail}</div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Requested files</div>
                        <div className="flex flex-col gap-2 justify-center items-center">
                          {document.documents?.map((file, index) => (
                            <Link
                              to={file.path}
                              key={`file-${index}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {file.displayKey}
                            </Link>
                          ))}
                        </div>
                      </div>
                      <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                        <div className="font-bold">Action</div>
                        <div>
                          <select
                            value={document.status}
                            onChange={(event) =>
                              handleDocumentStatus(
                                document.profileId,
                                event.target.value
                              )
                            }
                            className="p-2 border border-gray-500 dark:border-white rounded-md dark:bg-darkBg2"
                          >
                            <option value={null} disabled>
                              Select
                            </option>
                            <option value={"PENDING"}>Pending</option>
                            <option value={"APPROVED"}>Approved</option>
                            <option value={"DECLINED"}>Declined</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </>
                ))) || (
                <div className="flex justify-center items-center h-20 border-x border-b border-gray-500 dark:border-white">
                  No matching records found.
                </div>
              )}
            </div>
          </div>
          <Paginate
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
        <Dialog open={openDialog} onOpenChange={setOpenDialog}>
          <DialogContent className="max-w-screen w-[calc(100vw-20px)] lg:ml-[120px] lg:w-[700px] max-h-[calc(100vh-calc(100vh/3))] overflow-auto select-none bg-gray-200 dark:bg-[#171d37] dark:text-[#c7d8eb]">
            <DialogHeader className={"flex flex-row"}>
              <h2 className="dark:text-[#c7d8eb] min-w-fit">
                Decline Listing request
              </h2>
              <div className="w-full flex justify-end">
                <X
                  className="cursor-pointer dark:text-[#c7d8eb]"
                  onClick={() => {
                    setOpenDialog(false);
                  }}
                  size={30}
                />
              </div>
            </DialogHeader>
            <hr className="border-t-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)] -mt-3" />
            <div className="flex w-full flex-col">
              <h2 className="text-xl dark:text-[#c7d8eb]">
                <label htmlFor="reason">Reason</label>
              </h2>
              <p className="text-red-500 mb-0">*Required</p>
              <p className="text-red-500">*At least 20 characters</p>
              <div className="w-full"></div>
              <div className="flex flex-col gap-1 mt-1">
                {reasonError && (
                  <p className="text-red-500">This field is required</p>
                )}
              </div>
            </div>
            <hr className="border-t-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)]" />
            <DialogFooter></DialogFooter>
          </DialogContent>
        </Dialog>
        <AlertDialog open={openAlertDialog} onOpenChange={setOpenAlertDialog}>
          <AlertDialogContent className="max-w-screen w-[calc(100vw-20px)] lg:w-[700px] max-h-[calc(100vh-calc(100vh/3))] overflow-auto select-none bg-gray-200 dark:bg-[#171d37] dark:text-[#c7d8eb]">
            <AlertDialogHeader>
              <AlertDialogTitle>
                <h2 className="dark:text-[#c7d8eb] min-w-fit">
                  Are you sure you want to approve this listing
                </h2>
              </AlertDialogTitle>
              <AlertDialogDescription>
                Approving this listing will allow the host to list it for
                clients
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter
              className={"flex justify-end gap-2 items-center"}
            >
              <AlertDialogCancel>
                <div onClick={() => setOpenAlertDialog(false)}>Cancel</div>
              </AlertDialogCancel>
              <AlertDialogAction></AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default DocumentVerification;
